export type NiveauId = '6e' | '5e' | '4e' | '3e';

export type DomaineId =
  | 'fluence'
  | 'comprehension'
  | 'vocabulaire'
  | 'grammaire'
  | 'ecriture'
  | 'oral'
  | 'culture';

export const NIVEAUX: ReadonlyArray<{ id: NiveauId; libelle: string; actif: boolean }> = [
  { id: '6e', libelle: '6e', actif: true },
  { id: '5e', libelle: '5e', actif: false },
  { id: '4e', libelle: '4e', actif: false },
  { id: '3e', libelle: '3e', actif: false },
];

export const NIVEAU_PAR_DEFAUT: NiveauId = '6e';

export const DOMAINES: ReadonlyArray<{ id: DomaineId; titre: string }> = [
  { id: 'fluence', titre: 'Fluence' },
  { id: 'comprehension', titre: 'Compréhension' },
  { id: 'vocabulaire', titre: 'Vocabulaire et lexique' },
  { id: 'grammaire', titre: 'Grammaire' },
  { id: 'ecriture', titre: 'Écriture' },
  { id: 'oral', titre: 'Oral' },
  { id: 'culture', titre: 'Culture littéraire et artistique' },
];

export const BILAN = { titre: 'Bilan', to: '/mini-apps/francais-college/bilan' };

export function niveauDepuisUrl(valeur: string | null): NiveauId {
  const trouve = NIVEAUX.find((n) => n.id === valeur && n.actif);
  return trouve ? trouve.id : NIVEAU_PAR_DEFAUT;
}
